import { render, staticRenderFns } from "./Cabine.vue?vue&type=template&id=caf327fe"
import script from "./Cabine.vue?vue&type=script&lang=js"
export * from "./Cabine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports